import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatComplianceDocumentLastSavedAt } from './formatComplianceDocumentLastSavedAt'
import type {
  ComplianceDocumentI18nNamespace,
  ComplianceDocumentTranslationKeyPrefix,
} from './complianceDocumentEditorTypes'

const REFRESH_INTERVAL_MS = 30_000

export function useComplianceDocumentLastSavedLabel(
  lastSavedAt: Date | null,
  translationKeyPrefix: ComplianceDocumentTranslationKeyPrefix,
  i18nNamespace: ComplianceDocumentI18nNamespace
): string | null {
  const { t, i18n } = useTranslation(i18nNamespace)
  const [refreshTick, setRefreshTick] = useState(0)

  useEffect(() => {
    if (lastSavedAt == null) {
      return
    }
    const intervalId = window.setInterval(() => {
      setRefreshTick((previous) => previous + 1)
    }, REFRESH_INTERVAL_MS)
    return () => {
      window.clearInterval(intervalId)
    }
  }, [lastSavedAt])

  return useMemo(() => {
    if (lastSavedAt == null) {
      return null
    }
    void refreshTick
    const formattedTime = formatComplianceDocumentLastSavedAt(
      lastSavedAt,
      i18n.language
    )
    return t(`${translationKeyPrefix}.lastSavedAt`, { time: formattedTime })
  }, [i18n.language, lastSavedAt, refreshTick, t, translationKeyPrefix])
}
